module.exports = __webpack_public_path__ + "static/img/docs-sit.5ee6c0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/Uphc/Uphc-pics/docs-sit.jpg
// module id = d9dE
// module chunks = 0